module.exports = __webpack_public_path__ + "img/y4.21d7d9bd.jpg";